<div nz-row>
  <div nz-col [nzSpan]="24">
    <div class="form-title" [innerHTML]="'LOGIN_PAGE.MFA_TITLE' | translate"></div>
  </div>
</div>
<nz-spin
  class="mobiapp-spin login-spin"
  [nzSpinning]="login.authActionLoading$ | async"
  nzTip="{{ 'COMMON.LAYOUT.LOADING' | translate }}"
  nzSize="large"
  [nzIndicator]="indicatorTemplate">
  <form nz-form [formGroup]="login.mfaForm" class="login-form login-form--mfa" name="loginMfaForm" novalidate>
    <p
      id="login-mfa-description"
      class="mfa-description"
      [innerHTML]="'LOGIN_PAGE.MFA_DESCRIPTION' | translate: { phoneNumber: login.maskedPhoneNumber }"></p>
    <fieldset class="mfa-code-fieldset" [formArrayName]="'digits'" aria-describedby="login-mfa-description">
      <legend class="mfa-code-legend">
        {{ 'LOGIN_PAGE.MFA_CODE_LABEL' | translate }}
      </legend>
      <div class="mfa-code-inputs">
        @for (control of login.mfaCodeControls; track control; let i = $index) {
          <div class="mfa-code-input-wrapper">
            <input
              #mfaDigitInput
              class="mfa-code-input"
              type="text"
              inputmode="numeric"
              autocomplete="one-time-code"
              maxlength="1"
              pattern="[0-9]"
              [attr.aria-invalid]="login.mfaErrorMessage ? 'true' : null"
              [attr.aria-label]="'LOGIN_PAGE.MFA_DIGIT_ARIA_LABEL' | translate: { position: i + 1, total: 6 }"
              [formControlName]="i"
              (input)="login.onMfaDigitInput($event, i)"
              (keydown)="login.onMfaKeyDown($event, i)"
              (paste)="login.onMfaPaste($event)" />
          </div>
        }
      </div>
    </fieldset>

    @if (login.mfaErrorMessage) {
      <div class="error-message-container" role="alert">
        <p [innerHTML]="login.mfaErrorMessage | translate"></p>
      </div>
    }

    @if (login.mfaRequestMessage) {
      <div class="mfa-helper-message" aria-live="polite" [innerHTML]="login.mfaRequestMessage | translate"></div>
    }

    @if ((login.authActionLoading$ | async) === false) {
      <div nz-row>
        <div nz-col [nzSpan]="24">
          <button
            (click)="login.submitMfaForm()"
            class="submit-button"
            [disabled]="!login.isMfaCodeComplete || (login.authActionLoading$ | async)"
            mat-raised-button
            color="primary">
            {{ 'LOGIN_PAGE.MFA_SUBMIT' | translate }}
          </button>
        </div>
      </div>
    }

    @if (login.resendCooldownSeconds > 0) {
      <p
        class="mfa-helper-message"
        aria-live="polite"
        [innerHTML]="'LOGIN_PAGE.MFA_RESEND_WAIT' | translate: { seconds: login.resendCooldownSeconds }"></p>
    }

    @if (login.resendCooldownSeconds === 0) {
      <button
        type="button"
        class="secondary-link-button"
        [disabled]="login.authActionLoading$ | async"
        (click)="login.resendMfaCode()">
        {{ 'LOGIN_PAGE.MFA_RESEND' | translate }}
      </button>
    }

    <button
      type="button"
      class="secondary-link-button"
      [disabled]="login.authActionLoading$ | async"
      (click)="login.backToCredentials()">
      {{ 'LOGIN_PAGE.MFA_BACK' | translate }}
    </button>
  </form>
</nz-spin>
<ng-template #indicatorTemplate>
  <span nz-icon nzType="loading" class="ant-spin-dot"></span>
</ng-template>
